import { KBarResults, useMatches } from "kbar";
import { ResultsContainer, SectionHeader, ResultItem, ShortcutBadge, NoResults } from "./styled";
import Icon from "@components/Icon/Icon";
import { FileOutlined } from "@ant-design/icons";

export const RenderResults = () => {
    const { results } = useMatches();

    if (results.length === 0) {
        return (
            <ResultsContainer>
                <NoResults>No results found. Try searching for pages, actions, or content.</NoResults>
            </ResultsContainer>
        );
    }

    return (
        <ResultsContainer>
            <KBarResults
                items={results}
                onRender={({ item, active }) =>
                    typeof item === "string" ? (
                        <SectionHeader>{item}</SectionHeader>
                    ) : (
                        <ResultItem $active={active}>
                            <Icon
                                icon={FileOutlined}
                                color={`${active ? "var(--primary-button-text)" : "var(--text-base)"}`}
                            />
                            <span>{item.name}</span>
                            {item.shortcut && item.shortcut.length > 0 && (
                                <ShortcutBadge>
                                    {item.shortcut.map((key, index) => (
                                        <span key={index}>
                                            {key.toUpperCase()}
                                            {index < item.shortcut!.length - 1 && " + "}
                                        </span>
                                    ))}
                                </ShortcutBadge>
                            )}
                        </ResultItem>
                    )
                }
            />
        </ResultsContainer>
    );
};
